export interface OnlineTransportConfig {
  partyKitHost: string;
}

let forcedPartyKitHost: string | null = null;

const IS_TEST = typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';
const DEFAULT_PARTYKIT_HOST_FOR_TEST = 'localhost:1999';

function readMetaEnv(): ImportMetaEnv | undefined {
  if (typeof import.meta === 'undefined') return undefined;
  return import.meta.env;
}

function readProcessEnv(): Record<string, string | undefined> | undefined {
  if (typeof process === 'undefined') return undefined;
  return process.env;
}

function normalizeHost(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  try {
    const hasProtocol = /^https?:\/\//i.test(trimmed) || /^wss?:\/\//i.test(trimmed);
    if (hasProtocol) {
      const parsed = new URL(trimmed);
      return parsed.host || null;
    }
  } catch {
    // Fallback to permissive normalization below.
  }

  return trimmed.replace(/^\/+|\/+$/g, '');
}

function readPartyKitHostFromEnv(): string | null {
  const metaEnv = readMetaEnv();
  const processEnv = readProcessEnv();
  const configuredHost = normalizeHost(metaEnv?.VITE_PARTYKIT_HOST ?? processEnv?.VITE_PARTYKIT_HOST);
  if (configuredHost) return configuredHost;
  return IS_TEST ? DEFAULT_PARTYKIT_HOST_FOR_TEST : null;
}

export function resolveOnlineTransportConfig(): OnlineTransportConfig {
  const partyKitHost = forcedPartyKitHost === null
    ? readPartyKitHostFromEnv()
    : forcedPartyKitHost;

  if (!partyKitHost) {
    throw new Error('PartyKit host missing: set VITE_PARTYKIT_HOST');
  }

  return { partyKitHost };
}

export function overridePartyKitHostForTests(value: string | null) {
  if (value === null) {
    forcedPartyKitHost = null;
    return;
  }
  forcedPartyKitHost = value.trim().length === 0 ? '' : normalizeHost(value);
}
